export const HOSTS_THING_TYPE = 'DFEdges';
export const DEVICES_THING_TYPE = 'DFDevices';
export const HOSTS = 'Hosts';
export const DEVICES = 'Devices';

export const COLUMN_DEFINITIONS = {
    DFEdges: [
        {
            id: 'labID',
            header: 'Lab id',
            cell: (e) => e.labID,
            sortingField: 'labID',
        },
        {
            id: 'hostName',
            header: 'Host name',
            cell: (e) => e.hostName,
            sortingField: 'hostName',
        },
        {
            id: 'hostRegion',
            header: 'Host region',
            cell: (e) => e.hostRegion,
            sortingField: 'hostRegion',
        },
        {
            id: 'activateStatus',
            header: 'Active status',
            cell: (e) => e.activateStatus,
            sortingField: 'activateStatus',
        },
        {
            id: 'connectionStatus',
            header: 'Connection status',
            cell: (e) => e.connectionStatus,
            sortingField: 'connectionStatus',
        },
    ],
    DFDevices: [
        {
            id: 'name',
            header: 'Device name',
            cell: (e) => e.name,
            sortingField: 'name',
        },
        {
            id: 'host',
            header: 'Tethered host',
            cell: (e) => e.host,
            sortingField: 'host',
        },
        {
            id: 'dsn',
            header: 'DSN',
            cell: (e) => e.dsn,
            sortingField: 'dsn',
        },
        {
            id: 'buildProject',
            header: 'Build project',
            cell: (e) => e.buildProject,
            sortingField: 'buildProject',
        },
        {
            id: 'buildType',
            header: 'Build type',
            cell: (e) => e.buildType,
            sortingField: 'buildType',
        },
        {
            id: 'buildVersion',
            header: 'Build version',
            cell: (e) => e.buildVersion,
            sortingField: 'buildVersion',
        },
        {
            id: 'buildVariant',
            header: 'Build variant',
            cell: (e) => e.buildVariant,
            sortingField: 'buildVariant',
        },
        {
            id: 'connectStatus',
            header: 'Connect status',
            cell: (e) => e.connectStatus,
            sortingField: 'connectStatus',
        },
        {
            id: 'family',
            header: 'Family',
            cell: (e) => e.family,
            sortingField: 'family',
        },
        {
            id: 'locale',
            header: 'Locale',
            cell: (e) => e.locale,
            sortingField: 'locale',
        },
        {
            id: 'model',
            header: 'Model',
            cell: (e) => e.model,
            sortingField: 'model',
        },
        {
            id: 'storage',
            header: 'Storage',
            cell: (e) => e.storage,
            sortingField: 'storage',
        },
        {
            id: 'user',
            header: 'Registered user',
            cell: (e) => e.user,
            sortingField: 'user',
        },
        {
            id: 'wifiStatus',
            header: 'WIFI status',
            cell: (e) => e.wifiStatus,
            sortingField: 'wifiStatus',
        },
    ],
};

export const FILTER_SETS = {
    DFEdges: {
        labID: {
            options: [{ value: 'all', label: 'Lab id' }],
            selectedOption: { value: 'all', label: 'Lab id' },
        },
        hostRegion: {
            options: [{ value: 'all', label: 'Host region' }],
            selectedOption: { value: 'all', label: 'Host region' },
        },
        activateStatus: {
            options: [{ value: 'all', label: 'Host activation status' }],
            selectedOption: { value: 'all', label: 'Host activation status' },
        },
        connectionStatus: {
            options: [{ value: 'all', label: 'Host connection status' }],
            selectedOption: { value: 'all', label: 'Host connection status' },
        },
    },
    DFDevices: {
        name: {
            options: [{ value: 'all', label: 'Device name' }],
            selectedOption: { value: 'all', label: 'Device name' },
        },
        host: {
            options: [{ value: 'all', label: 'Tethered host' }],
            selectedOption: { value: 'all', label: 'Tethered host' },
        },
        family: {
            options: [{ value: 'all', label: 'Device family' }],
            selectedOption: { value: 'all', label: 'Device family' },
        },
        buildProject: {
            options: [{ value: 'all', label: 'Device build project' }],
            selectedOption: { value: 'all', label: 'Device build project' },
        },
        buildType: {
            options: [{ value: 'all', label: 'Device build type' }],
            selectedOption: { value: 'all', label: 'Device build type' },
        },
        buildVersion: {
            options: [{ value: 'all', label: 'Device build version' }],
            selectedOption: { value: 'all', label: 'Device build version' },
        },
        buildVariant: {
            options: [{ value: 'all', label: 'Device build variant' }],
            selectedOption: { value: 'all', label: 'Device build variant' },
        },
        connectStatus: {
            options: [{ value: 'all', label: 'Device connect status' }],
            selectedOption: { value: 'all', label: 'Device connect status' },
        },
        locale: {
            options: [{ value: 'all', label: 'Device locale' }],
            selectedOption: { value: 'all', label: 'Device locale' },
        },
        model: {
            options: [{ value: 'all', label: 'Device model' }],
            selectedOption: { value: 'all', label: 'Device model' },
        },
        storage: {
            options: [{ value: 'all', label: 'Device storage' }],
            selectedOption: { value: 'all', label: 'Device storage' },
        },
        user: {
            options: [{ value: 'all', label: 'Device user' }],
            selectedOption: { value: 'all', label: 'Device user' },
        },
        wifiStatus: {
            options: [{ value: 'all', label: 'Device WIFI status' }],
            selectedOption: { value: 'all', label: 'Device WIFI status' },
        },
    },
};

export const TABLE_LOOK_UP_PLACEHODLER = {
    [HOSTS_THING_TYPE]: 'Find hostname',
    [DEVICES_THING_TYPE]: 'Find device DSN',
};

export const EXPORTED_CSV_HEADERS = {
    DFEdges: [
        { label: 'Lab id', key: 'labID' },
        { label: 'Host name', key: 'hostName' },
        { label: 'Host region', key: 'hostRegion' },
        { label: 'Active status', key: 'activateStatus' },
        { label: 'Connection status', key: 'connectionStatus' },
    ],
    DFDevices: [
        { label: 'Device name', key: 'name' },
        { label: 'Tethered host', key: 'host' },
        { label: 'DSN', key: 'dsn' },
        { label: 'Build project', key: 'buildProject' },
        { label: 'Build type', key: 'buildType' },
        { label: 'Build version', key: 'buildVersion' },
        { label: 'Build variant', key: 'buildVariant' },
        { label: 'Connect status', key: 'connectStatus' },
        { label: 'Family', key: 'family' },
        { label: 'Locale', key: 'locale' },
        { label: 'Model', key: 'model' },
        { label: 'Storage', key: 'storage' },
        { label: 'Registered user', key: 'user' },
        { label: 'WIFI status', key: 'wifiStatus' },
    ],
};
